import Icon from '../components/Icon.vue'

Icon.register({"share-square":{"width":576,"height":512,"paths":[{"d":"M568.5 177.4L424.5 313.4C409.3 327.8 384 317.1 384 296V224C239.4 225 178.4 259.1 219.2 395.4 223.7 410.3 206.4 421.9 194.2 412.7 155.3 383.1 120 326.5 120 269.3 120 125.4 237.6 96.8 384 96V24C384 2.8 409.3-7.8 424.5 6.6L568.5 142.6C578.5 152 578.5 168 568.5 177.4zM384 379.1V448H64V128H114.9A12-12 0 0 1 123.6 124.3C138.5 108.7 155.8 96.4 174.6 86.6 185.7 80.8 181.6 64 169 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V375.2C448 366.9 439.8 361.1 432 363.9A71.8-71.8 0 0 0 397.8 367.3C390.5 366.2 384 371.8 384 379.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/share-square.js
// module id = null
// module chunks = 